import React, { useEffect } from "react";
import { Button, Form, Input } from "antd";
import { CloseOutlined, SearchOutlined } from "@ant-design/icons";
import { Localize } from "components/service";
import { useTranslation } from "components/use-hooks";
import StaffWorkersRoleSelect from "../forms/fields/staff-workers-role-select";
import StaffWorkersSubcontractorSelect from "../forms/fields/staff-workers-subcontractor-select";


const { Search } = Input;

const StaffWorkersTableFilter = ({
    eventRoles,
    searchText,
    setSearchText,
    roleID,
    setRoleID,
    subcontractorID,
    setSubcontractorID,
    resetPage,
}) => {
    const [ form ] = Form.useForm();
    const translations = useTranslation();
    const hasRole = !!roleID;
    const hasSubcontractor = !!subcontractorID;
    const hasFilters = !!(searchText || hasRole || hasSubcontractor);
    const searchWorkerLabel = translations[ "STAFF_MANAGEMENT.Filter_SearchName" ] || "Search for name";

    useEffect(() => {
        form.setFieldsValue({
            role_id: roleID,
            subcontractor_id: subcontractorID,
        });
    }, [ form, roleID, subcontractorID ]);

    const clearFilters = () => {
        setSearchText("");
        setRoleID(undefined);
        setSubcontractorID(undefined);
        form.resetFields([ "role_id", "subcontractor_id" ]);
        resetPage();
    };

    return (
        <Form form={ form } component={ false }>
            <div className="d-flex align-items-center table-action-bar form-controls-compact staff-table-filter staff-table-filter--workers">
                <div className="d-flex align-items-center table-filter-form staff-table-filter__controls staff-workers-filter__controls">
                    <Search
                        allowClear={ { clearIcon: <CloseOutlined /> } }
                        aria-label={ searchWorkerLabel }
                        className="filter-search"
                        prefix={ <SearchOutlined /> }
                        placeholder={ searchWorkerLabel }
                        value={ searchText }
                        onChange={ (event) => {
                            setSearchText(event.target.value);
                            resetPage();
                        } } />

                    <StaffWorkersRoleSelect
                        eventRoles={ eventRoles }
                        form={ form }
                        selected={ hasRole }
                        onChange={ (value) => {
                            setRoleID(value);
                            resetPage();
                        } } />

                    <StaffWorkersSubcontractorSelect
                        form={ form }
                        selected={ hasSubcontractor }
                        onChange={ (value) => {
                            setSubcontractorID(value);
                            resetPage();
                        } } />

                    { hasFilters &&
                        <Button className="btn-text-link" type="link" onClick={ clearFilters }>
                            <Localize>STAFF_MANAGEMENT.Action_ClearAll</Localize>
                        </Button>
                    }
                </div>
            </div>
        </Form>
    );
};

export default StaffWorkersTableFilter;
